import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import * as yup from "yup";
import { api } from "../../../api/apiService";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const schema = yup.object().shape({
    password: yup
      .string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
    password_confirmation: yup
      .string()
      .oneOf([yup.ref("password")], "Passwords must match")
      .required("Password confirmation is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const { token } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const submitForm = async (data) => {
    setIsLoading(true);
    setFormErrors({});

    try {
      const email = new URLSearchParams(location.search).get("email");
      const response = await api.post(`/reset-password/${token}?email=${email}`, {
        token,
        email,
        password: data.password,
        password_confirmation: data.password_confirmation,
      });

      toast.success("Password reset successfully");
      // Redirect to login page after a delay
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (error) {
      if (error.data && error.data.errors) {
        error.data.errors.forEach(err => {
          toast.error(err);
        });
      } else {
        toast.error("An unexpected error occur");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-6 col-md-8">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title text-center">Reset Your Password</h5>
              <form onSubmit={handleSubmit(submitForm)} className="needs-validation">
                {/* Password Field */}
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    New Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    className={`form-control ${errors.password ? "is-invalid" : ""}`}
                    {...register("password")}
                  />
                  {errors.password && (
                    <div className="invalid-feedback">{errors.password.message}</div>
                  )}
                  {formErrors.password && (
                    <div className="text-danger text-sm">{formErrors.password[0]}</div>
                  )}
                </div>

                {/* Confirm Password Field */}
                <div className="mb-3">
                  <label htmlFor="passwordConfirmation" className="form-label">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    id="passwordConfirmation"
                    className={`form-control ${errors.password_confirmation ? "is-invalid" : ""
                      }`}
                    {...register("password_confirmation")}
                  />
                  {errors.password_confirmation && (
                    <div className="invalid-feedback">
                      {errors.password_confirmation.message}
                    </div>
                  )}
                  {formErrors.password_confirmation && (
                    <div className="text-danger text-sm">
                      {formErrors.password_confirmation[0]}
                    </div>
                  )}
                </div>

                {/* Submit Button */}
                <div className="mb-3">
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={isLoading || !isValid}
                  >
                    {isLoading ? "Resetting Password..." : "Reset Password"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
